import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "children", "disabled", "isSelected", "icon", "size", "href", "tooltipContent"];
import { Plus } from "lucide-react";
import React from "react";
import Tooltip from "../Tooltip";
import { BaseIconButton, BaseIconButtonLink } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var IconButton = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var onClick = _ref.onClick,
    children = _ref.children,
    disabled = _ref.disabled,
    isSelected = _ref.isSelected,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/_jsx(Plus, {}) : _ref$icon,
    size = _ref.size,
    href = _ref.href,
    tooltipContent = _ref.tooltipContent,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var IconButtonComponent = href ? BaseIconButtonLink : BaseIconButton;
  return /*#__PURE__*/_jsx(Tooltip, {
    content: tooltipContent,
    children: /*#__PURE__*/_jsx(IconButtonComponent, _extends({
      ref: forwardedRef,
      "aria-label": tooltipContent,
      selected: isSelected,
      onClick: onClick,
      disabled: disabled,
      size: size,
      href: href,
      type: "button"
    }, restProps, {
      children: icon
    }))
  });
});
IconButton.displayName = "IconButton";
export default IconButton;